// Libraries
import { TextProps } from '@chakra-ui/react';

/**
 * Enum representing the direction values of 'up' and 'down'.
 */
export enum Direction {
  up = 'up',
  down = 'down',
}

/**
 * Type representing the keys of the Direction enum.
 */
export type DirectionKeys = keyof typeof Direction;

/**
 * Props type for the IconText component.
 */
export type IconTextProps = TextProps & {
  /**
   * Optional direction for the icon.
   */
  direction?: DirectionKeys;

  /**
   * Optional flag indicating whether the component is loaded.
   */
  isLoading?: boolean;
};
